import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _approveAllJoinGroupRequestsRequest = {};
var _approveAllJoinGroupRequestsResponse = {
    joinGroupRequests: '_joinGroupRequest',
};
var _approveJoinGroupRequestsRequest = {};
var _approveJoinGroupRequestsResponse = {
    joinGroupRequests: '_joinGroupRequest',
};
var _cancelJoinGroupRequestRequest = {};
var _cancelJoinGroupRequestResponse = {
    joinGroupRequest: '_joinGroupRequest',
};
var _getJoinRequirementsRequest = {};
var _getJoinRequirementsResponse = { violation: '_violation' };
var _joinGroupRequest = { createdDate: 'google.protobuf.Timestamp' };
var _listAllJoinGroupRequestsRequest = {};
var _listAllJoinGroupRequestsResponse = {
    joinGroupRequests: '_joinGroupRequest',
};
var _listJoinGroupRequestsRequest = {};
var _listJoinGroupRequestsResponse = {
    joinGroupRequests: '_joinGroupRequest',
};
var _paidPlan = { startsAt: 'google.protobuf.Timestamp' };
var _pricingPlanViolationOptions = {
    requiredPlans: '_paidPlan',
    futurePlans: '_paidPlan',
};
var _queryJoinGroupRequestsRequest = {};
var _queryJoinGroupRequestsResponse = {
    joinGroupRequests: '_joinGroupRequest',
};
var _rejectAllJoinGroupRequestsRequest = {};
var _rejectAllJoinGroupRequestsResponse = {
    joinGroupRequests: '_joinGroupRequest',
};
var _rejectJoinGroupRequestsRequest = {};
var _rejectJoinGroupRequestsResponse = {
    joinGroupRequests: '_joinGroupRequest',
};
var _submitJoinGroupRequestRequest = {};
var _submitJoinGroupRequestResponse = {
    joinGroupRequest: '_joinGroupRequest',
};
var _violation = { pricingPlansOptions: '_pricingPlanViolationOptions' };
function resolveWixSocialGroupsApiV2JoinGroupRequestsServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/join-proxy',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/social-groups-proxy/join',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/social-groups-proxy/join',
                destPath: '',
            },
            {
                srcPath: '/_api/join-proxy',
                destPath: '',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/social-groups-proxy/join',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/join',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/join',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/social-groups-proxy/join',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/social-groups-proxy/join',
                destPath: '',
            },
        ],
        'groups.wixapps.net': [
            {
                srcPath: '/_api/social-groups-proxy/join',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/join',
                destPath: '',
            },
            {
                srcPath: '/social-groups-proxy/api/join',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/join',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/social-groups-proxy/join',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Get join group requirements. Will return empty response for public groups and details to fulfil if it's private. */
export function getJoinRequirements(payload) {
    var _a = serializer(_getJoinRequirementsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getJoinRequirementsResponse, {
        _paidPlan: _paidPlan,
        _pricingPlanViolationOptions: _pricingPlanViolationOptions,
        _violation: _violation,
    }).fromJSON;
    function __getJoinRequirements(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.join_group_request',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v2.JoinGroupRequestsService.GetJoinRequirements',
            url: resolveWixSocialGroupsApiV2JoinGroupRequestsServiceUrl({
                protoPath: '/v2/groups/{groupId}/join-requests/requirements',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getJoinRequirements.fromReq = fromReq;
    __getJoinRequirements.__isAmbassador = true;
    return __getJoinRequirements;
}
/**
 * Submits a join group request.
 * Relevant only for private groups.
 */
export function submitJoinGroupRequest(payload) {
    var _a = serializer(_submitJoinGroupRequestRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_submitJoinGroupRequestResponse, {
        _joinGroupRequest: _joinGroupRequest,
    }).fromJSON;
    function __submitJoinGroupRequest(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.join_group_request',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v2.JoinGroupRequestsService.SubmitJoinGroupRequest',
            url: resolveWixSocialGroupsApiV2JoinGroupRequestsServiceUrl({
                protoPath: '/v2/groups/{groupId}/join-requests',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __submitJoinGroupRequest.fromReq = fromReq;
    __submitJoinGroupRequest.__isAmbassador = true;
    return __submitJoinGroupRequest;
}
/**
 * Cancels a join group request.
 * A site member can cancel only their own pending Join group requests.
 */
export function cancelJoinGroupRequest(payload) {
    var _a = serializer(_cancelJoinGroupRequestRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelJoinGroupRequestResponse, {
        _joinGroupRequest: _joinGroupRequest,
    }).fromJSON;
    function __cancelJoinGroupRequest(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.join_group_request',
            method: 'DELETE',
            methodFqn: 'wix.social.groups.api.v2.JoinGroupRequestsService.CancelJoinGroupRequest',
            url: resolveWixSocialGroupsApiV2JoinGroupRequestsServiceUrl({
                protoPath: '/v2/groups/{groupId}/join-requests',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelJoinGroupRequest.fromReq = fromReq;
    __cancelJoinGroupRequest.__isAmbassador = true;
    return __cancelJoinGroupRequest;
}
/**
 * Approves pending join group requests.
 * Group managers always have access to this functionality. In some cases, site owners will allow group members to use this functionality as well.
 */
export function approveJoinGroupRequests(payload) {
    var _a = serializer(_approveJoinGroupRequestsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_approveJoinGroupRequestsResponse, {
        _joinGroupRequest: _joinGroupRequest,
    }).fromJSON;
    function __approveJoinGroupRequests(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.join_group_request',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v2.JoinGroupRequestsService.ApproveJoinGroupRequests',
            url: resolveWixSocialGroupsApiV2JoinGroupRequestsServiceUrl({
                protoPath: '/v2/groups/{groupId}/join-requests/approve',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __approveJoinGroupRequests.fromReq = fromReq;
    __approveJoinGroupRequests.__isAmbassador = true;
    return __approveJoinGroupRequests;
}
/**
 * Rejects pending join group requests.
 * Group managers always have access to this functionality. In some cases, site owners will allow group members to use this functionality as well.
 */
export function rejectJoinGroupRequests(payload) {
    var _a = serializer(_rejectJoinGroupRequestsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rejectJoinGroupRequestsResponse, {
        _joinGroupRequest: _joinGroupRequest,
    }).fromJSON;
    function __rejectJoinGroupRequests(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.join_group_request',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v2.JoinGroupRequestsService.RejectJoinGroupRequests',
            url: resolveWixSocialGroupsApiV2JoinGroupRequestsServiceUrl({
                protoPath: '/v2/groups/{groupId}/join-requests/reject',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __rejectJoinGroupRequests.fromReq = fromReq;
    __rejectJoinGroupRequests.__isAmbassador = true;
    return __rejectJoinGroupRequests;
}
/**
 * Retrieves a list of up to 100 join group requests, given the provided paging.
 *
 * Default sorts to created date in descending order.
 *
 * Only group admins can see requests to join their group. Site members can access their own join requests in a site.
 */
export function listJoinGroupRequests(payload) {
    var _a = serializer(_listJoinGroupRequestsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listJoinGroupRequestsResponse, {
        _joinGroupRequest: _joinGroupRequest,
    }).fromJSON;
    function __listJoinGroupRequests(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.join_group_request',
            method: 'GET',
            methodFqn: 'wix.social.groups.api.v2.JoinGroupRequestsService.ListJoinGroupRequests',
            url: resolveWixSocialGroupsApiV2JoinGroupRequestsServiceUrl({
                protoPath: '/v2/groups/{groupId}/join-requests',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listJoinGroupRequests.fromReq = fromReq;
    __listJoinGroupRequests.__isAmbassador = true;
    return __listJoinGroupRequests;
}
/**
 * Retrieves a list of up to 100 join group requests, given the provided paging and filtering.
 * Group managers always have access to this functionality (site members can access their own join group requests in the site).
 *
 * Supported fields for filtering:
 * - `status`
 *
 * No supported fields for sorting
 */
export function queryJoinGroupRequests(payload) {
    var _a = serializer(_queryJoinGroupRequestsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryJoinGroupRequestsResponse, {
        _joinGroupRequest: _joinGroupRequest,
    }).fromJSON;
    function __queryJoinGroupRequests(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.join_group_request',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v2.JoinGroupRequestsService.QueryJoinGroupRequests',
            url: resolveWixSocialGroupsApiV2JoinGroupRequestsServiceUrl({
                protoPath: '/v2/groups/{groupId}/join-requests/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryJoinGroupRequests.fromReq = fromReq;
    __queryJoinGroupRequests.__isAmbassador = true;
    return __queryJoinGroupRequests;
}
export function rejectAllJoinGroupRequests(payload) {
    var _a = serializer(_rejectAllJoinGroupRequestsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rejectAllJoinGroupRequestsResponse, { _joinGroupRequest: _joinGroupRequest }).fromJSON;
    function __rejectAllJoinGroupRequests(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.join_group_request',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v2.JoinGroupRequestsService.RejectAllJoinGroupRequests',
            url: resolveWixSocialGroupsApiV2JoinGroupRequestsServiceUrl({
                protoPath: '/v2/groups/join-requests/reject',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __rejectAllJoinGroupRequests.fromReq = fromReq;
    __rejectAllJoinGroupRequests.__isAmbassador = true;
    return __rejectAllJoinGroupRequests;
}
export function approveAllJoinGroupRequests(payload) {
    var _a = serializer(_approveAllJoinGroupRequestsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_approveAllJoinGroupRequestsResponse, { _joinGroupRequest: _joinGroupRequest }).fromJSON;
    function __approveAllJoinGroupRequests(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.join_group_request',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v2.JoinGroupRequestsService.ApproveAllJoinGroupRequests',
            url: resolveWixSocialGroupsApiV2JoinGroupRequestsServiceUrl({
                protoPath: '/v2/groups/join-requests/approve',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __approveAllJoinGroupRequests.fromReq = fromReq;
    __approveAllJoinGroupRequests.__isAmbassador = true;
    return __approveAllJoinGroupRequests;
}
export function listAllJoinGroupRequests(payload) {
    var _a = serializer(_listAllJoinGroupRequestsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listAllJoinGroupRequestsResponse, {
        _joinGroupRequest: _joinGroupRequest,
    }).fromJSON;
    function __listAllJoinGroupRequests(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.join_group_request',
            method: 'GET',
            methodFqn: 'wix.social.groups.api.v2.JoinGroupRequestsService.ListAllJoinGroupRequests',
            url: resolveWixSocialGroupsApiV2JoinGroupRequestsServiceUrl({
                protoPath: '/v2/groups/join-requests/list',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData, true),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listAllJoinGroupRequests.fromReq = fromReq;
    __listAllJoinGroupRequests.__isAmbassador = true;
    return __listAllJoinGroupRequests;
}
//# sourceMappingURL=http.impl.js.map